import { useTranslation } from 'react-i18next'
import { useUser } from '@fs/zion-user'
import { useFeatureFlag } from '@fs/zion-flags'
import { i18n } from '@fs/zion-locale'

export default function useMemoriesLinks() {
  const { t } = useTranslation()
  const { isOn: showFamilyFeedLink } = useFeatureFlag('home_header_familyFeed')
  const { isOn: showReactGallery } = useFeatureFlag('memories_gallery')
  const { isOn: hideMemoriesPeople } = useFeatureFlag('memories_eol_disable_people')
  const { isOn: hideMemoriesFind } = useFeatureFlag('memories_eol_disable_find')
  const { signedIn } = useUser()

  const memoriesLinks = {
    id: 'memories',
    text: t('nav.memories', 'Memories'),
    sub: [
      { id: 'overview', text: t('nav.overview', 'Overview'), url: '/memories/' },
      {
        id: 'gallery',
        text: t('nav.memories.gallery', 'Gallery'),
        url: `/${showReactGallery ? 'memories' : 'photos'}/gallery`,
      },
      {
        id: 'people',
        text: t('nav.memories.people', 'People'),
        url: `/${hideMemoriesPeople ? 'memories' : 'photos'}/people`,
      },
      {
        id: 'find',
        text: t('nav.memories.find', 'Find'),
        url: `/${hideMemoriesFind ? 'memories' : 'photos'}/find`,
      },
      {
        id: 'family-feed',
        text: t('nav.memories.family-feed', 'Family Feed'),
        url: `/${i18n.language}/home/portal/feed`,
      },
    ],
  }

  memoriesLinks.sub = memoriesLinks.sub.filter((link) => {
    let keep = true

    if (link.id === 'family-feed' && (!showFamilyFeedLink || !signedIn)) {
      keep = false
    }

    return keep
  })

  return memoriesLinks
}
